import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getBackendURL } from '../../utils/backendURL';

export default function useOpsUserDirectory({ searchTerm, planFilter, currentPage, usersPerPage }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accountType, setAccountType] = useState('');
  const requestId = useRef(0);
  const fetchUsers = useCallback(async ({ background = false } = {}) => {
    const id = ++requestId.current;
    if (!background) setLoading(true);
    try {
      const params = new URLSearchParams({ skip: (currentPage - 1) * usersPerPage, limit: usersPerPage });
      if (searchTerm) params.set('search', searchTerm);
      if (planFilter) params.set('plan_filter', planFilter);
      if (accountType) params.set('account_type', accountType);
      const { data } = await axios.get(`${getBackendURL()}/api/ops/users?${params}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
      });
      if (id === requestId.current) { setUsers(data); setError(null); }
    } catch (failure) {
      if (id === requestId.current) setError('Failed to load users');
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, [searchTerm, planFilter, currentPage, usersPerPage, accountType]);
  useEffect(() => {
    fetchUsers();
    return () => { requestId.current += 1; };
  }, [fetchUsers]);
  return { users, loading, error, setLoading, fetchUsers, accountType, setAccountType };
}
